// GiftCategory.js
import { connect } from 'react-redux';
import GiftCategory from '../component/GiftCategory.jsx';

import fetchGifts from '../action/fetchGifts.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

function mapStateToProps(state, { category }) {
  const selectPath = ['gift', 'item', category];
  const nextPage = getListData(state, selectPath, 'nextPage');
  return {
    itemIds: getListData(state, selectPath, 'itemIds'),
    isFetched: !!getNetworkingData(state, [...selectPath, 1], 'isFetched'),
    isFirstPageFetching: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetching'
    ),
    isNextPageFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchGifts: ({ category, page }) =>
      dispatch(fetchGifts({ category, page })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCategory);
